import { Chip } from '@mui/material'
import React, { Fragment } from 'react'

export const renderOrigins = (namesOrderOrigin: any) => {
  if (!namesOrderOrigin || namesOrderOrigin.length === 0)
    return 'Sin configurar'

  const visibleItems = namesOrderOrigin.slice(0, 3)
  const masItems = namesOrderOrigin.length > 3

  return (
    <Fragment>
      {visibleItems.map((item: string, index: number) => (
        <Chip
          key={`${item}-${index}`}
          label={item === '' ? 'Sin Nombre' : item}
        />
      ))}

      {masItems && <Chip label='...' />}
    </Fragment>
  )
}
